<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" @click="$router.back()">考试仓管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">考试设备列表</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox">
            <div title="考试仓名称" class="searchboxItem ci-full">
              <span class="itemLabel">考试仓名称:{{ lastPageData.houseName }}</span>
            </div>
            <div title="设备名称" class="searchboxItem ci-full">
              <span class="itemLabel" style="min-width: 7em;">设备名称:</span>
              <el-input v-model="retrievalData.deviceName" type="text" size="small" placeholder="请输入设备名称" clearable />
            </div>
            <div title="设备类型" class="searchboxItem ci-full">
              <span class="itemLabel">设备类型:</span>
              <el-select v-model="retrievalData.deviceType" filterable clearable size="small" placeholder="请选择设备类型">
                <el-option v-for="item in deviceTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
            <el-button type="primary" class="bgc-bv" round @click="examDeviceEdit()">新增</el-button>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
              :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="设备名称" align="left" show-overflow-tooltip prop="deviceName" minWidth="200" />
              <el-table-column label="设备码" align="left" show-overflow-tooltip prop="deviceCode" minWidth="200" />
              <el-table-column label="设备类型" align="left" show-overflow-tooltip prop="deviceType" minWidth="100">
                <template slot-scope="scope">
                  {{ $setDictionary("EXAM_DEVICE_TYPE", scope.row.deviceType) }}
                </template>
              </el-table-column>
              <el-table-column label="创建时间" align="left" show-overflow-tooltip prop="createTime" minWidth="180" />
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button type="text" style="padding: 0px 5px" size="mini"
                    @click="examDeviceEdit(scope.row)">编辑</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini"
                    @click="examDeviceDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
export default {
  name: "examination_examHouseDevice",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      lastPageData: {
        houseName: "", // 考试仓名称
        examHouseId: null, // 考试仓id
      },
      // 检索数据
      retrievalData: {
        deviceName: "", // 设备名称
        deviceType: "", // 设备类型
      },
      // 设备类型 - 下拉数据
      deviceTypeList: [],
    };
  },
  created() {
    this.dataDictionary();
  },
  watch: {},
  computed: {},
  mounted() {
    // 读取路由参数examHouseId和houseName
    this.lastPageData.examHouseId = this.$route.query.examHouseId;
    this.lastPageData.houseName = this.$route.query.houseName;
    // 初始化加载数据
    this.getData();
  },
  methods: {
    // 获取 - 数据字典
    dataDictionary() {
      // 设备类型
      const deviceTypeList = this.$setDictionary(
        "EXAM_DEVICE_TYPE",
        "list"
      );
      const list1 = [];
      for (const key in deviceTypeList) {
        list1.push({
          value: key,
          label: deviceTypeList[key],
        });
      }
      this.deviceTypeList = list1;
    },
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
        examHouseId: this.lastPageData.examHouseId,
      };
      if (this.retrievalData.deviceName) {
        params.deviceName = this.retrievalData.deviceName;
      }
      if (this.retrievalData.deviceType) {
        params.deviceType = this.retrievalData.deviceType;
      }
      this.doFetch({
        url: "/biz/isec/exam-house/devicePageList",
        params,
        pageNum,
      }, true, 6);
    },
    // 操作 - 新增&编辑
    examDeviceEdit(row) {
      this.$router.push({
        path: "/web/examination/examHouse/examDeviceAddEdit",
        query: {
          examHouseId: this.lastPageData.examHouseId,
          deviceId: row?.deviceId ?? '',
          houseName: this.lastPageData.houseName,
        }
      });
    },
    // 操作 - 删除
    examDeviceDelete(row) {
      // 加上是否删除的confirm弹窗
      this.$confirm("是否删除该设备?", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButtonClass",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$post('/biz/isec/exam-house/deleteDevice', { deviceId: row.deviceId, examHouseId: this.lastPageData.examHouseId }, 3000, true, 6)
            .then((res) => {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.getData(this.pageNum)
            })
            .catch((err) => {
              return;
            });
        })
        .catch(() => {
          return;
        });

    }
  },
};
</script>
<style lang="less" scoped></style>
